import { httpClient } from "../http/httpClient";
import { PartnerType } from "@/app/utils/partners.enum";

export type PostSimulationParams = {
  cpf: string;
  typeSimulation:
    | "POR_VALOR_MAXIMO"
    | "POR_VALOR_SOLICITADO"
    | "POR_VALOR_PARCELA";
  value?: number;
  valor_parcela?: number;
  Prazo?: number;
};

export type SimulationCondition = {
  condicao: {
    id_simulacao: string;
    convenio: {
      codigo: string;
      descricao: string;
    };
    produto: {
      codigo: string;
      descricao: string;
    };
    quantidade_parcelas: number;
    valor_solicitado: number;
    valor_principal: number;
    valor_parcela: number;
    valor_bruto: number;
    valor_iof: number;
    valor_liquido: number;
    valor_cliente: number;
    data_primeiro_vencimento: string;
    data_ultimo_vencimento: string;
    custo_total_efetivo_mensal: number;
    custo_total_efetivo_anual: number;
    taxa_cliente_mensal: number;
    taxa_cliente_anual: number;
    despesas: unknown[];
    refinanciamento: unknown[];
    dados_bancarios: {
      numero_banco: string;
      numero_agencia: string;
      tipo_conta: string;
      numero_conta: string;
      digito_conta: string;
    };
  };
};

export type PostSimulationResponse = {
  condicoes_credito: SimulationCondition[];
  commission: number;
  requestAmount: number;
  installments: number[];
};

export const postSimulation = async (payload: PostSimulationParams) => {
  const { data } = await httpClient
    .post<PostSimulationResponse>("/c6/simulation", payload, {
      journey: PartnerType.C6,
    })
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
